import { registerPlatform } from '@core/registry';
import { Platform } from './Platform.js';
import { PlatformNoHandlers } from './PlatformNoHandlers.js';
// Gives the foundation packages (which never depend on the private platform client) the application's clients.
registerPlatform({
    platform: Platform,
    platformNoHandlers: PlatformNoHandlers
});

//# sourceMappingURL=SetupPackage.js.map